export default function LoginFail(){
    alert("올바른 접근이 아닙니다.");
    window.location.href="/login";
    localStorage.setItem('access_token', '');
    localStorage.setItem('refresh_token', '');
}